<script>
    import InputStepper from './InputStepper.svelte';

    export let label;
    export let placeholder = '';
    export let value;
    export let type = 'text';
    export let classNames = '';

    const handleInput = e => {
        value = type.match(/^(number|range)$/)
            ? +e.target.value
            : e.target.value;
    };
</script>

<div class="relative mb-4 {classNames}">
    {#if label}
        <label for="" class="px-4 pt-4 absolute text-neutral-500 font-medium text-sm top-0 inset-x-0 pointer-events-none">{label}</label>
    {/if}
    {#if type === 'number'}
        <InputStepper bind:value={value} />
    {/if}
    <input
        class="p-4 pt-10 text-white bg-gray-800 w-full rounded-lg"
        {placeholder}
        {type}
        {value}
        on:input={handleInput}
    >
</div>